import { createRoute, lazyFn } from '@tanstack/react-router';

import { RootRoute } from '$/routes/RootRoute';

export const LegacyInspirationEditorRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: '/inspirations/legacy/$id',
  loader: lazyFn(
    () => import('./LegacyInspirationEditorRoute.lazyFn'),
    'loader',
  ),
  onLeave: lazyFn(
    () => import('./LegacyInspirationEditorRoute.lazyFn'),
    'onLeave',
  ),
  staleTime: 0,
  preload: false,
}).lazy(() =>
  import('./LegacyInspirationEditorRoute.lazy').then(
    (d) => d.LazyLegacyInspirationEditorRoute,
  ),
);
